/* eslint-disable */
import Vue from 'vue'
import {getCommentsAPI, removeCommentAPI, setCommentAPI, getAnswersAPI, editCommentAPI} from "@/store/modules/wall/comments/commentAPI";
import {findCommentHelper, findPostHelper} from "@/store/modules/helpers/helpers.js";

export async function setComment({ commit }, { comment }) {
	let response = await setCommentAPI(Object.assign({}, comment))
	if (response && response.success) {
		comment = mergeComment(comment, response.data)

		commit('appendCommentToPost', { comment })
	}
	return (response) ? response.success : false
}

export async function editComment({ commit }, { comment } ) {
	let response = await editCommentAPI(comment)
	if (response && response.success) {
		comment = mergeComment(comment, response.data)
		commit('replaceCommentInPost', { comment })
	}
	return (response) ? response.success : false
}

export async function removeComment({ commit }, { comment, params }) {
	let // auth = await removeCommentAuthAPI(comment.id),
		response = await removeCommentAPI(comment.id, params)
	// if (auth.success && auth.data.is_author)
	// 	response = await removeCommentAPI(comment.id, 'author')

	if (response && response.success) {
		comment = mergeComment(comment, response.data)
		if (response.data.deleted_at)
			commit('removeCommentFromPost', { comment })
		else
			commit('replaceCommentInPost', { comment })
	}

	return response
}

function getPage({ post, sort, perPage }) {
	let currentSort = null;
	if(post.comments_sort) {
		currentSort = post.comments_sort;
	}
	// let currentSort = (typeof post.comments_sort === 'undefined') ? null : post.comments_sort
	if (post.comments_page && (currentSort === sort)) {
		return post.comments_page + 1
	} else {
		return (currentSort === sort) ? Math.floor((post.comments.length / perPage)) + 1 : 1
	}
}

export async function getComments({ commit, state }, { id, sort = null, root_id = null }) {
	let post = findPostHelper(state, id);
	console.log("GET COMMENTS PARAMS:", id, sort, root_id)
	console.log("FIND POST HERE IN GET COMMENTS:", post)
	let perPage = 3,
		params = {
			page: getPage({ post, sort, perPage }),
			per_page: perPage,
			sort_by: sort,
			root_id: root_id,
			comment_answers: 0
		},
		response = await getCommentsAPI(id, params)

	if (response.success) {
		let data = response.data
		commit('appendCommentsToPost', { id, data, sort })
	}
	return response
}

export async function getAnswers({ commit, state }, { postID, commentID }) {
	let post = findPostHelper(state, postID),
		comment = findCommentHelper(state, post, commentID),
		params = {
			page: (comment.answers_page) ? comment.answers_page + 1 : 1,
			per_page: 10
		},
		response = await getAnswersAPI(commentID, params)

	if (response.success) {
		let data = response.data
		commit('appendAnswersToComment', { postID, commentID, data })
	}
	return response
}

export function setQuotedCommentContent({ commit, state }, { comment }) {
	if (comment.root_id && comment.parent_id && (comment.root_id !== comment.parent_id)) {
		let post = findPostHelper(state, comment.post.id),
			quotedCommentParent = findCommentHelper(state, post, comment.root_id),
			quotedComment = quotedCommentParent.answers.find(x => x.id === comment.parent_id)

		Vue.set(comment, 'quote', {
			content: quotedComment.content,
			mentions: quotedComment.mention_users
		})
	}
}

function mergeComment(oldValue, newValue) {
	return Object.assign({
		post: {
			id: oldValue.post.id
		},
		parent_id: oldValue.parent_id
	}, newValue)
}
